module.exports = __webpack_public_path__ + "media/images/pic/home/book-waku-waku-148a269c305b925383d2441a7cbf1800.png";